$( document ).ready(function() {
  const variantId = $('.check-with-label:checked').attr('variant_id');
  
  $('#selected_variant_id').attr("value", variantId);
  $( ".label-for-check" ).on( "click", function() {
    var updatedVal = $(this).attr("variant_id");
    $('#selected_variant_id').attr("value", updatedVal);
  } );

  // $( "#add-to-cart-gift" ).on( "click", function() {
  //   event.preventDefault(); // prevent default form submission
  //   addToCart();
  // } );

  // function addToCart(elmRef) {
  //   var defaultProdId = document.getElementById("selected_variant_id").getAttribute("value");
  //   var properties = {
  //       'Recipient Name': document.getElementById("gift-Recipient-name").value,
  //       'Recipient email': document.getElementById("gift-Recipient-email").value,
  //       'Delivery Date': document.getElementById("gift-Delivery-date").value,
  //       'From': document.getElementById("gift-From").value,
  //       'Note': document.getElementById("gift-Note").value,
  //   };
  //   console.log(properties);
  //   const selectedProd = {
  //     id: defaultProdId,
  //     properties: properties
  //   }

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/add.js',
  //     data: selectedProd,
  //     dataType: 'json',
  //     success: function() {
  //       // Do something on success (e.g. show a success message)
  //       console.log('------------------added')
  //       getCart();
  //       //handleCartIconClick();
  //     },
  //     error: function() {
  //       // Do something on error (e.g. show an error message)
  //     }
  //   });
  //   //toggleDrawer(true, selectedProd, elmRef, true)
  // }

  // function getCart() {
  //   console.log('------------------get')
  //   var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
  //     .then(response => response.json())
  //     .then(data => {
  //       console.log('Got', data);
  //       // toggleDrawer(true, selectedProd, null);
  //     });

  // }
  
});